import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=65ee2506&scoped=true"
import script from "./Licence.vue?vue&type=script&lang=js"
export * from "./Licence.vue?vue&type=script&lang=js"
import style0 from "./Licence.vue?vue&type=style&index=0&id=65ee2506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee2506",
  null
  
)

export default component.exports